export const toTierKey = (value?: string | null) =>
  value?.toLowerCase().replace(/[^a-z0-9]/g, "") ?? "";
